import React, { useEffect, useState } from "react";
import { motion, useInView, useMotionValue, animate } from "framer-motion";
import SEO from "../../seo/SEO";
import { seoConfig } from "../../seo/seoConfig";
import {
  TbRocket,
  TbAtom,
  TbFileInvoice,
  TbUsersGroup,
  TbNetwork,
  TbSparkles,
  TbChartArrowsVertical,
} from "react-icons/tb";
import { HiOutlineOfficeBuilding, HiOutlineSparkles } from "react-icons/hi";
import { HiArrowRight } from "react-icons/hi";
import Badge from "../../components/Badge/Badge";
import Card from "../../components/Card/Card";
import FeatureIcon from "../../components/FeatureIcon/FeatureIcon";
import Button from "../../components/Button/Button";
import LazyImage from "../../components/LazyImage/LazyImage";
import styles from "./WhyIfillip.module.css";
import {
  ifillip_process_automation as dashImg,
  ifillip_deep_insights as dashImg2,
  ifillip_stakeholder_dashboard as dashImg7,
} from "../../controller/Image";
import { TbCloud, TbRadio, TbDeviceDesktop } from "react-icons/tb";
import HomeImageHero from "../../components/HomeImageHero/HomeImageHero";
import ImageContentSection from "../../components/ImageContentSection/ImageContentSection";
import FeatureAccordion from "../../components/FeatureAccordion/FeatureAccordion";
import CtaBanner from "../../components/CtaBanner/CtaBanner";
import image1 from "../../assets/images/Home/Smart Academic Workflow 1.png";
import image2 from "../../assets/images/Home/Streamlined Schedule Planning 1.png";
import image3 from "../../assets/images/Home/Digital School Ecosystem 1.png";
import textimage1 from "../../assets/images/Home/why-schools-india-1.png";
import textimage2 from "../../assets/images/Home/what-makes-ifillip-different-1.png";
import textimage3 from "../../assets/images/Home/ai-applications-education-1.png";
import textimage4 from "../../assets/images/Home/one-place-1.png";

const ECOSYSTEM_FEATURES = [
  {
    icon: TbCloud,
    title: "Cloud-Enabled Platform",
    text: "iFillip is a cloud-enabled platform with a secure and scalable infrastructure. It ensures real-time data availability, smooth collaboration across stakeholders, and seamless data synchronization.",
  },
  {
    icon: TbRadio,
    title: "RFID-Based Attendance",
    text: "With the RFID (Radio Frequency Identification) approach, iFillip automates students' daily attendance by enabling real-time attendance tracking and syncing data within the student attendance management software, keeping teachers and parents notified.",
  },
  {
    icon: TbDeviceDesktop,
    title: "Digitalize Your Workflows",
    text: "With iFillip, reduce paperwork and eliminate human errors. Switch smarter and streamline your academic workflows such as admissions, attendance, and performance digitally. iFillip can be accessed quickly across all devices and operating systems, offering a fast and mobile-friendly platform.",
  },
];

const items = [
  {
    subtitle: "Why Schools in India Need AI-Powered Platforms Like iFillip",
    description: (
      <>
        <p>
          With over 250 millions of students across 1.5 millions schools, in
          India making it as one of the worlds largest educational system.
          However, most of the educational institutions still rely on the
          traditional methods such as manual attendance and lack of proper
          communication between the teachers, parents
        </p>

        <p>According to multiple education digitization studies in India:</p>

        <ul>
          <li>
            Nearly 65% of schools still use partially manual administrative
            systems
          </li>
          <li>
            Teachers spends around 30% of their time on non-teaching tasks
          </li>
          <li>
            Schools using digital platforms report up to 3x improvement in
            operational efficiency
          </li>
        </ul>

        <p>
          This gap highlights the urgent need for integrated schooling apps that
          combine automation, analytics, and communication in one unified
          system. iFillip addresses this need by acting as a complete AI-powered
          academic ecosystem.
        </p>
      </>
    ),
    image: textimage1,
  },

  {
    subtitle: "What Makes iFillip Different from Traditional School Software",
    description: (
      <>
        <p>
          Unlike other school ERP systems, which offers limited features like
          online attendance, iFillip comes with the AI integration tools such as
          AI powered Adaptive learning, AI powered data analytics to transform
          school operations smarter.
        </p>

        <h3>1. AI-Driven Academic Intelligence Tools</h3>

        <p>
          iFillip brings ai in education and analyzes the both students and
          teachers performance patters and teaching, learning progresses. This
          helps in the
        </p>

        <ul>
          <li>Identify weak learners early</li>
          <li>Personalize lesson plans in teaching</li>
          <li>
            Improved assessments outcomes in the predictive analytics insights
          </li>
        </ul>

        <h3>2. End-to-End Learning Management System for Schools</h3>

        <ul>
          <li>Digital lesson planning and curriculum mapping</li>
          <li>Online assignments and assessments</li>
          <li>Study material distribution</li>
          <li>Real-time performance metrics</li>
        </ul>

        <p>
          This approach eliminates the use of multiple tools connected for
          academic co-ordination across departments.
        </p>

        <h3>3. Smart Automation for School Administration</h3>

        <ul>
          <li>AI-based admission tracking systems</li>
          <li>RFID- Attendance tracking</li>
          <li>Timetable optimization tools</li>
          <li>Smart exam scheduling</li>
        </ul>

        <p>
          Schools using similar automation systems globally have reported up to
          40–60% reduction in administrative workload, allowing educators to
          focus more on teaching.
        </p>
      </>
    ),
    image: textimage2,
  },

  {
    subtitle:
      "AI Applications in Education: How iFillip is Changing the Classroom Experience",
    description: (
      <>
        <p>
          The role of AI applications in education is no longer experimental it
          is becoming essential. iFillip integrates AI into daily academic
          workflows to improve both teaching and learning experiences.
        </p>

        <h3>Personalized Learning at Scale</h3>

        <ul>
          <li>
            Assigning the assessments to students based on the performances
          </li>
          <li>Generating the AI enabled quizzes, assigned to students.</li>
        </ul>

        <p>
          This ensures very students receive a personalized learning experiences
          understanding the class demographics.
        </p>

        <h3>Data driven insights</h3>

        <ul>
          <li>Attendance consistency</li>
          <li>Student engagement levels</li>
        </ul>

        <p>
          This helps schools to take the right decisions, and teachers can plan
          accordingly easily.
        </p>
      </>
    ),
    image: textimage3,
  },

  {
    subtitle:
      "Schooling Apps that connects stake holders all together in one place",
    description: (
      <>
        <ul>
          <li>Instant announcements and notifications</li>
          <li>Parent-teacher communication channels</li>
          <li>Real-time academic updates</li>
        </ul>

        <p>This eliminates the communication-gaps,</p>

        <h3>Access iFillip Anytime, Any Where on any device</h3>

        <ul>
          <li>Mobile-first accessibility</li>
          <li>Cloud-based data synchronization</li>
          <li>Secure logins</li>
        </ul>
      </>
    ),
    image: textimage4,
  },

  {
    subtitle: "Why iFillip is Built for the Future of Indian Education",
    description: (
      <>
        <p>
          The future of education system in India can be expected to be hybrid,
          data driven. Government initiatives such as Digital India and National
          Education Policy 2020 highlighted integration of technology across
          classrooms making AI school managements systems like iFillip relevant
          to the trends
        </p>

        <ul>
          <li>Scalable cloud infrastructure for schools of all sizes</li>
          <li>AI-powered analytics for academic improvement</li>
          <li>Integrated communication and management tools</li>
        </ul>
      </>
    ),
    image: textimage2,
  },
];

const features = [
  {
    id: 1,
    title: "Smart Academic Workflow",
    description:
      "iFillip is built as a structured school management platform, ensuring that every academic workflows and administrative function is organized in a way to easy to access. This structured module clearly helps schools to streamline the academic operations without disorder.",
    image: image1,
  },
  {
    id: 2,
    title: "Streamlined Schedule Planning",
    description:
      "One of the key strengths of the iFillip is its timetable management system, that allows schools to create, manage, and modify the class schedules dynamically. This reduces the conflicts and improves the better coordination among the teachers and students, saving time.",
    image: image2,
  },
  {
    id: 3,
    title: "Digital School Ecosystem",
    description:
      "iFillip also functions as a smart school ecosystem, combining announcements and news into a unified interface for better engagement. The study materials acts as a centralized resource where teachers can upload notes, assignments, and learning content. This helps students and parents never miss important news updates, academic alerts and institutional notifications. To strengthen the communication among the stakeholders, iFillip features a notification, alerts and announcements module that provides the real-time academic updates, happenings in the school, reducing the communication gaps. With the role-based communication module ensures the messages, updates, and alerts are delivered based on every user's role, such as school admins, teachers, parents and students, improving the effective interaction.",
    image: image3,
  },
];

/* ============================================================
   PIE CHART DATA + COMPONENT
   Mirrors the working HTML exactly:
   - plain <circle> elements with stroke-dasharray
   - CSS @keyframes animation triggered by .donutInView class
   - CSS :hover for the stroke-width grow effect
   useInView is only used to toggle the .donutInView class
   when the chart scrolls into view.
============================================================ */

const PIE_DATA = {
  traditional: {
    title: "Traditional System",
    subtitle: "Burdened by Routine Tasks",
    slices: [
      {
        label: "Administrative tasks",
        sub: "(attendance, records)",
        value: 30,
        color: "#818CF8",
      },
      {
        label: "Parent communications",
        sub: "(meetings, calls, SMS)",
        value: 15,
        color: "#06B6D4",
      },
      {
        label: "Reports & analytics",
        sub: "(manual collation)",
        value: 20,
        color: "#14B8A6",
      },
      { label: "Teaching & learning", sub: "", value: 35, color: "#8B5CF6" },
    ],
  },
  ifillip: {
    title: "iFillip World",
    subtitle: "Empowered to Inspire Students",
    slices: [
      {
        label: "Administrative tasks",
        sub: "(automated)",
        value: 10,
        color: "#818CF8",
      },
      {
        label: "Parent communications",
        sub: "(in-app)",
        value: 5,
        color: "#06B6D4",
      },
      {
        label: "Reports & analytics",
        sub: "(AI-driven)",
        value: 5,
        color: "#14B8A6",
      },
      { label: "Teaching & learning", sub: "", value: 80, color: "#8B5CF6" },
    ],
  },
};

const CIRC = 2 * Math.PI * 80; // ≈ 502.65

const AnimatedDonutChart = ({ data }) => {
  const wrapRef = React.useRef(null);
  const isInView = useInView(wrapRef, { once: true, amount: 0.3 });

  let cumulative = 0;
  const slices = data.slices.map((s) => {
    const length = (s.value / 100) * CIRC;
    const offset = -cumulative;
    const midAngleDeg = ((cumulative + length / 2) / CIRC) * 360;
    cumulative += length;
    const rad = (midAngleDeg * Math.PI) / 180;
    const labelX = 100 + 80 * Math.sin(rad);
    const labelY = 100 - 80 * Math.cos(rad);
    return { ...s, length, offset, labelX, labelY };
  });

  return (
    <div className={styles.donutWrap} ref={wrapRef}>
      <svg
        viewBox="0 0 200 200"
        className={`${styles.donutSvg} ${isInView ? styles.donutInView : ""}`}
        role="img"
        aria-label={`${data.title} pie chart`}
      >
        {slices.map((s, i) => (
          <circle
            key={`slice-${i}`}
            className={styles.donutSlice}
            cx="100"
            cy="100"
            r="80"
            stroke={s.color}
            strokeDasharray={`${s.length.toFixed(2)} ${CIRC.toFixed(2)}`}
            strokeDashoffset={s.offset.toFixed(2)}
            style={{ animationDelay: `${i * 0.3}s` }}
          />
        ))}
        {slices.map((s, i) => (
          <text
            key={`label-${i}`}
            className={styles.donutLabel}
            x={s.labelX}
            y={s.labelY}
            textAnchor="middle"
            dominantBaseline="middle"
            style={{
              animationDelay: `${1.0 + i * 0.3}s`,
              fontSize:
                s.value < 8 ? 9 : s.value < 15 ? 11 : s.value > 50 ? 18 : 14,
            }}
          >
            {s.value}%
          </text>
        ))}
      </svg>

      <ul className={styles.donutLegend}>
        {data.slices.map((s, i) => (
          <li key={i} className={styles.donutLegendItem}>
            <span
              className={styles.donutSwatch}
              style={{ background: s.color }}
            />
            <span className={styles.donutLegendText}>
              <strong>{s.label}</strong>
              {s.sub && <span className={styles.donutLegendSub}> {s.sub}</span>}
              <span className={styles.donutLegendValue}> — {s.value}%</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

/* ============================================================
   COUNT-UP NUMBER (unchanged)
============================================================ */

const CountUpNumber = ({
  target,
  duration = 1.6,
  decimals = 0,
  prefix = "",
  suffix = "",
}) => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!isInView) return;
    const controls = animate(0, target, {
      duration,
      ease: "easeOut",
      onUpdate: (latest) => {
        setValue(
          decimals > 0
            ? parseFloat(latest.toFixed(decimals))
            : Math.round(latest),
        );
      },
    });
    return () => controls.stop();
  }, [isInView, target, duration, decimals]);

  const display = decimals > 0 ? value.toFixed(decimals) : value;
  return (
    <span ref={ref}>
      {prefix}
      {display}
      {suffix}
    </span>
  );
};

/* ============================================================
   MAIN COMPONENT
============================================================ */

const WhyIfillip = () => {
  return (
    <>
      <SEO {...seoConfig.whyIfillip} />
      <div className={styles.page}>
        <HomeImageHero />
        {/* ============ HERO ============ */}
        <section className={`page-container ${styles.heroSection}`}>
          <Badge variant="cyan">Next-Gen School Management</Badge>
          <div className="row align-items-center g-5">
            <div className="col-12">
              <h1 className={styles.heroTitle}>
                Step into the Future with iFillip's{" "}
                <span className="gradientText">
                  AI-Powered School Management System
                </span>
              </h1>
            </div>
            <div className="col-12">
              <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <section
                  className={`page-container p-0 ${styles.aiMainSection}`}
                >
                  <div className={styles.card}>
                    <p className="normalText">
                      With more than 25Cr students studying across 15 lakh
                      schools, India has emerged as one of the largest education
                      systems globally. Tamil Nadu alone has about 1Cr students
                      and 45000 schools and most of the educational institutions
                      rely on the traditional educational systems. In real-time,
                      providing individual attention to every student is
                      impractical. Even in schools where the latest technologies
                      like ERP and Computerized systems are implemented, they
                      mainly focus on the automation of their operational
                      activities.
                    </p>

                    <p className="normalText">
                      As education continues to evolve, personalized teaching
                      and adaptive learning are being implemented or piloted in
                      fewer schools. This clearly indicates that the future of
                      school education lies in embracing adaptive learning
                      solutions to achieve better academic outcomes and
                      long-term educational excellence.
                    </p>

                    <p className="normalText">
                      iFillip transforms the academic management landscape with
                      its AI powered school management system. Wherein, beyond
                      the operations automations, iFillip brings in Personalized
                      Teaching and Adaptive Learning as the key elements for
                      leading to the Future Education. iFillip enables schools
                      to engage with the students and track their learning
                      patterns and performance levels with the power of
                      Artificial Intelligence to make the education more
                      effective and focused on individual student level.
                    </p>

                    <h3 className="subtitle" style={{ marginTop: "1.5rem" }}>
                      Platform and Flexible Cost Model
                    </h3>

                    <p className="normalText">
                      Designed on a contemporary cloud architecture, iFillip is
                      capable of integrating with a variety of hardware,
                      including PCs, laptops, RFID scanners, mobile phones, and
                      tablet computers. Using IoT technology, this platform
                      helps educational institutions to perform their operations
                      with greater efficiency while providing them real-time
                      access to data from any location.
                    </p>

                    <p className="normalText">
                      Offering support in two languages - Tamil and English,
                      iFillip caters to a variety of educational institutions
                      while being flexible to change as future technologies
                      evolve. Schools can opt for either a license-based or SaaS
                      subscription model to suit their respective preferences
                      and budget requirements.
                    </p>
                  </div>
                </section>
              </motion.div>
            </div>
            {/* 
          <div className="col-12 col-lg-4">
            <motion.div
              className={styles.heroDash}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.1 }}
            >
              <img
                src={dashImg2}
                alt="iFillip school management platform dashboard showing real-time process automation and institutional health metrics"
                className={styles.dashImg}
              />
              <div className={styles.consensusChip}>
                <FeatureIcon icon={TbAtom} tint="purple" size="sm" />
                <div>
                  <div className={styles.chipLabel}>OPERATIONAL HEALTH</div>
                  <div className={styles.chipValue}>
                    <CountUpNumber
                      target={94.2}
                      decimals={1}
                      suffix="% Process Automation"
                    />
                  </div>
                </div>
              </div>
            </motion.div>
          </div> */}
          </div>
        </section>

        {/* <div>
        <FeatureAccordion
          title="Building Smart Schools with"
          gradientTitle="AI-Powered Learning Ecosystems"
          items={features}
          defaultOpenIndex={0}
        />
      </div> */}
        <section className="full-width-section">
          <div className={`page-container ${styles.heroSection}`}>
            <div className="row align-items-center g-5">
              <div className="col-12">
                <h1 className={styles.heroTitle}>
                  <span className="gradientText">
                    Automating School Operations for
                  </span>{" "}
                  Academic Excellence
                </h1>
              </div>
              <div className="col-12 col-lg-6">
                <motion.div
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  <section
                    className={`page-container p-0 ${styles.aiMainSection}`}
                  >
                    <div className={styles.card}>
                      <p className="normalText">
                        iFillip transforms the way schools manage their daily
                        operations, enabling teachers to focus on the core
                        activities like teaching, mentoring, and nurturing
                        students. In a traditional school environment, a
                        significant amount of teachers' time is spent on routine
                        administrative tasks such as maintenance of records and
                        other operational responsibilities resulting in reducing
                        the time available for student engagement.
                      </p>
                      <p className="normalText">
                        iFillip automates mundane activities like attendance,
                        parent-teacher-student communication and also ensures
                        seamless access to information. By using iFillip,
                        schools can operate more efficiently by reducing manual
                        workload allowing school authorities to deliver quality
                        education, support student growth and foster academic
                        excellence.
                      </p>
                    </div>
                  </section>
                </motion.div>
              </div>

              <div className="col-12 col-lg-6">
                <motion.div
                  className={styles.heroDash}
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.7, delay: 0.1 }}
                >
                  <LazyImage
                    {...dashImg}
                    alt="iFillip school management platform dashboard showing real-time process automation and institutional health metrics"
                    wrapperClassName={styles.dashImg}
                  />
                  <div className={styles.consensusChip}>
                    <FeatureIcon icon={TbAtom} tint="purple" size="sm" />
                    <div>
                      <div className={styles.chipLabel}>OPERATIONAL HEALTH</div>
                      <div className={styles.chipValue}>
                        <CountUpNumber
                          target={94.2}
                          decimals={1}
                          suffix="% Process Automation"
                        />
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </section>

        {/* ============================================================
          EFFORT COMPARISON CHARTS — pure CSS animation
      ============================================================ */}
        <section className={`page-container ${styles.chartsSection}`}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className={styles.chartsHeader}
          >
            <h2 className={styles.chartsTitle}>
              Effort Distribution:{" "}
              <span className="gradientText">Traditional vs iFillip</span>
            </h2>
            <p className={styles.chartsSubtitle}>
              More teaching. More mentoring. More success.
            </p>
          </motion.div>

          <div className="row g-4">
            <div className="col-12 col-lg-6">
              <motion.div
                className={styles.chartCard}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                whileHover={{ y: -6, transition: { duration: 0.25 } }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <h3 className={styles.chartCardTitle}>
                  {PIE_DATA.traditional.title}
                </h3>
                <p className={styles.chartCardSubtitle}>
                  {PIE_DATA.traditional.subtitle}
                </p>
                <AnimatedDonutChart data={PIE_DATA.traditional} />
              </motion.div>
            </div>

            <div className="col-12 col-lg-6">
              <motion.div
                className={`${styles.chartCard} ${styles.chartCardHighlight}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                whileHover={{ y: -6, transition: { duration: 0.25 } }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.15 }}
              >
                <h3 className={styles.chartCardTitle}>
                  {PIE_DATA.ifillip.title}
                </h3>
                <p className={styles.chartCardSubtitle}>
                  {PIE_DATA.ifillip.subtitle}
                </p>
                <AnimatedDonutChart data={PIE_DATA.ifillip} />
              </motion.div>
            </div>
          </div>
        </section>

        {/* ============ COMPARISON SECTION ============ */}
        <section className={styles.comparisonSection}>
          <div className="page-container">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className={styles.comparisonHeader}>
                <span className={styles.comparisonEyebrow}>
                  The iFillip Advantage
                </span>
                <h2 className={styles.comparisonTitle}>
                  Reimagining Education for an{" "}
                  <span className={styles.gradientHighlight}>
                    AI-Powered Future
                  </span>
                </h2>
                {/* <p className={styles.comparisonLead}>
          See how iFillip transforms every aspect of school operations.
        </p> */}
              </div>

              {/* Column headers */}
              <div className={styles.columnHeaderRow}>
                <div className={styles.headerSpacer}></div>
                <div className={styles.headerTraditional}>
                  <HiOutlineOfficeBuilding className={styles.headerIcon} />
                  <span>Traditional School</span>
                </div>
                <div className={styles.headerSpacer}></div>
                <div className={styles.headerIfillip}>
                  <HiOutlineSparkles className={styles.headerIconCyan} />
                  <span>With iFillip</span>
                </div>
              </div>

              <div className={styles.comparisonGrid}>
                {[
                  {
                    label: "Engagement",
                    before: "Passive Learning Environment",
                    after: "Engaged & Collaborative Learning",
                  },
                  {
                    label: "Academic Standards",
                    before: "Periodic evaluation only",
                    after: "AI-driven adaptive learning",
                  },
                  {
                    label: "Record Accuracy",
                    before: "High error, manual entry",
                    after: "Automated, near zero errors",
                  },
                  {
                    label: "Decisions",
                    before: "Slow, fragmented data",
                    after: "Predictive, AI analytics",
                  },
                  {
                    label: "Stakeholders communication",
                    before: "Delayed updates",
                    after: "Accurate Records, Seamless Updates",
                  },
                  {
                    label: "Technology Cost",
                    before: "High upfront investment",
                    after: "Minimal SaaS hosting",
                  },
                  {
                    label: "Scalability",
                    before: "Infrastructure-Dependent Growth",
                    after: "SaaS-Powered Scalability",
                  },
                ].map((row, idx) => (
                  <motion.div
                    key={row.label}
                    className={styles.compareRow}
                    initial={{ opacity: 0, x: -16 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: idx * 0.06 }}
                  >
                    <div className={styles.rowLabel}>{row.label}</div>

                    <div className={styles.beforeCell}>
                      <span className={styles.cellTag}>Traditional</span>
                      <div className={styles.cellInner}>
                        <span className={styles.dotRed}></span>
                        <span className={styles.beforeText}>{row.before}</span>
                      </div>
                    </div>

                    <HiArrowRight className={styles.transformArrow} />

                    <div className={styles.afterCell}>
                      <span className={styles.cellTagCyan}>With iFillip</span>
                      <div className={styles.cellInner}>
                        <span className={styles.dotCyan}></span>
                        <span className={styles.afterText}>{row.after}</span>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </section>
        {/* Leverage Deep Insights Section */}
        <section className={`page-container ${styles.deepInsightsSection}`}>
          <h1 className={styles.heroTitle}>
            <span className="gradientText">Leverage Deep Insights and</span>{" "}
            Improve Quality of Education
          </h1>
          <div className="row align-items-center g-5">
            <div className="col-12 col-lg-6 order-lg-2">
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <LazyImage
                  {...dashImg2}
                  alt="AI Analytics Dashboard"
                  wrapperClassName={styles.insightsImage}
                />
              </motion.div>
            </div>
            <div className="col-12 col-lg-6 order-lg-1">
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <p className="normalText">
                  iFillip’s intelligent data tracking & analysis keeps track of
                  all the activities across school management ecosystem and
                  provides deep insights on key performance indicators ensuring
                  continuous monitoring of various performance parameters at
                  different levels – Student, Teacher & School Levels.
                </p>
                <p className="normalText">
                  Key Performance tracking indices include
                </p>
                <ul className={styles.insightsList}>
                  <li>
                    Academic performance across individuals and classrooms
                  </li>
                  <li>Identifying learning gaps and guide remedial actions</li>
                  {/* <li>
                  Generate data-driven reports that help in understanding what
                  is happening at a glance
                </li> */}
                </ul>
                <p className="normalText">
                  This enables the various stakeholders to access vital data any
                  time and act accordingly.
                </p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* All Stakeholders Connect Section */}
        <section className={`page-container ${styles.stakeholdersSection}`}>
          <div className="row align-items-center g-5">
            <div className="col-12 col-lg-6">
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <LazyImage
                  {...dashImg7}
                  alt="Stakeholder Dashboards"
                  wrapperClassName={styles.stakeholdersImage}
                />
              </motion.div>
            </div>
            <div className="col-12 col-lg-6">
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <h2 className={styles.sectionTitle}>
                  Connected Stakeholders. Stronger Educational Outcomes.
                </h2>
                <p className="normalText">
                  Collaboration among the stakeholders is critical for imparting
                  effective education. IFillip acts as a bridge that brings all
                  stakeholders – students, parents, teachers and school
                  authorities on a single platform, thus enabling transparency,
                  continuous engagement and informed decision-making.
                </p>
                <p className="normalText">
                  With role-based control (RBAC), iFillip ensures that the right
                  information reaches the right individual at the right time. By
                  having visibility on school updates to student well-being,
                  academic progress and performance insights, every stakeholder
                  remains aligned with student`s growth.
                </p>
                <p className="normalText">
                  Parents gain greater visibility into their child's
                  performance; teachers can connect better with pupils and their
                  parents and school authorities benefit from a unified view of
                  institutional performance. By eliminating communication gaps
                  and creating a single source of truth, iFillip enables
                  meaningful collaboration across the entire school community.
                </p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Digital Eco System Section */}
        {/* <section className={`page-container ${styles.digitalEcoSection}`}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className={styles.sectionTitle}>
            Digital Eco System with Smart Academic Workflows
          </h2>
          <p className="normalText">
            iFillip provides an organized, role-based framework for managing
            both academic and administrative tasks from a specific dashboard.
            Few Key workflows include:
          </p>
          <ul className={styles.workflowList}>
            <li>
              AI Assisted lesson plan creation, submission of lesson plans for
              schedules to the Head of the Institution for approvals, Following
              approvals/reworks can happen through paperless automated
              e-Workflows
            </li>
            <li>
              Assigning assessments and tracking submissions and the necessary
              remedial processes can happen through automated e-Workflows
            </li>
          </ul>
          <p className="normalText">
            The workflows help teachers to spend more time on teaching, and
            ensure administrators to spend less time on paper work.
          </p>
          <p className="normalText">
            As mentioned earlier, iFillip connects all stakeholders (students,
            parents, teachers, and administrators) into a single, secure
            platform with Bi-lingual support for both Tamil and English. This
            unified ecosystem ensures that no information is missed and keeps
            everyone informed.
          </p>
          <ul className={styles.ecoList}>
            <li>
              Ensures Announcements, News, and event notifications are delivered
              to stakeholders instantly in real-time
            </li>
            <li>
              The School Management can monitor KPIs and manage well in time
            </li>
            <li>
              Teachers can upload learning materials, assignments, and resources
              to students
            </li>
            <li>
              Parents can get real-time information on attendance, assessments,
              and exam schedules
            </li>
            <li>
              Secure and transparent messaging between teachers, parents, and
              school management
            </li>
          </ul>
        </motion.div>
      </section> */}

        {/* Automated Administration Section */}
        <section className={`${styles.ecosystemSection}`}>
          <div className="page-container">
            <motion.header
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className={styles.ecosystemHeader}
            >
              <h2 className={styles.ecosystemTitle}>
                {/* Automated Administration Improves{" "} */}
                <span className={styles.cyanGlow}>
                  Smarter Administration Starts Here.
                </span>
              </h2>
              <p
                className="normalText"
                style={{ color: "rgba(255,255,255,0.8)" }}
              >
                One of the primary advantages of iFillip's{" "}
                <a
                  href="/ai-suite"
                  style={{
                    color: "inherit",
                    textDecoration: "underline",
                    fontWeight: 700,
                  }}
                >
                  AI-powered school management system
                </a>{" "}
                is that it reduces the workload in daily academic tasks.
              </p>
            </motion.header>

            <div className="row g-4">
              <div className="col-12 col-md-6">
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                  className={styles.ecoCard}
                >
                  <h3 className={styles.ecoTitle}>
                    Online Attendance Management System: Accurate, Automated,
                    and Effortless
                  </h3>
                  <p className={styles.ecoText}>
                    Manual attendance registers are a well-known source of
                    errors, proxy fraud, and administrative overhead. iFillip's
                    online attendance management system uses IoT-enabled RFID
                    integration to automate attendance tracking and eliminate
                    manual errors. . Powered by IoT integration, it can be
                    connected to RFID readers and delivers:
                  </p>
                  <ul className={styles.ecoListLight}>
                    <li>
                      Real-time student and staff attendance tracking without
                      classroom roll calls
                    </li>
                    <li>Instant absence alerts sent to parents</li>
                    <li>
                      Reduced administrative workload improving operational
                      efficacy
                    </li>
                    <li>
                      Less manual work for teachers means more focus on students
                    </li>
                  </ul>
                  {/* <p className={styles.ecoText}>
                  Less manual work for teachers means more focus on students
                </p> */}
                </motion.div>
              </div>
              <div className="col-12 col-md-6">
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className={styles.ecoCard}
                >
                  <h3 className={styles.ecoTitle}>
                    Online Admissions Management System
                  </h3>
                  <p className={styles.ecoText}>
                    Admissions are often the first interaction parents have with
                    any educational institution. Therefore, it is imperative to
                    make the process transparent and seamless. iFillip's Online
                    Admissions Management module helps schools move away from
                    traditional, manual process to a more convenient digital
                    experience by automating the various activities to a
                    centralized platform. Applicants can apply from anywhere,
                    upload required documents and receive real-time updates on
                    their application status without the need for contacting the
                    concerned authorities.
                  </p>
                  <ul className={styles.ecoListLight}>
                    <li>Online portal accessible anytime, from any device</li>
                    <li>Easy document collection and verification workflows</li>
                    <li>
                      Real-time application status updates and notifications
                    </li>
                    <li>
                      Removes dependency on manual paperwork and visits to
                      schools for updates
                    </li>
                    <li>
                      Automatic transfer of applicant details upon enrollment
                    </li>
                  </ul>
                </motion.div>
              </div>
            </div>
          </div>
        </section>

        {/* COGNITIVE FLOW SECTION - Updated */}
        {/* <section className={`page-container ${styles.cognitive}`}>
        <Card variant="default" padding="lg" className={styles.cognitiveCard}>
          <div className="row align-items-center g-4">
            <div className="col-12 col-lg-6">
              <span className={styles.innoEyebrow}>
                <span className={styles.innoDash} /> START YOUR TRANSFORMATION
              </span>
              <h3 className={styles.cognitiveTitle}>
                Start Your School's{" "}
                <span className="gradientText">Transformation Today</span>
              </h3>
              <p className="normalText">
                Transform your school, college, or educational institution into
                a smarter, more effective learning environment — powered by
                India's most capable AI-powered school management system.
              </p>
              <p className="normalText">
                With iFillip, you get more than software. You get a strategic
                partner committed to the academic success of every student in
                your institution. From an IoT-powered online attendance
                management system to a fully digital online admissions
                management system, from AI-driven adaptive learning to real-time
                financial reporting — iFillip covers every dimension of modern
                school management.
              </p>
            </div>
            <div className="col-12 col-lg-6 text-center">
              <div className={styles.syncOrb}>
                <div className={styles.syncInner}>
                  <div className={styles.syncBar}>
                    <motion.div
                      className={styles.syncFill}
                      initial={{ width: "0%" }}
                      whileInView={{ width: "100%" }}
                      viewport={{ once: true }}
                      transition={{ duration: 1.6, ease: "easeOut" }}
                    />
                  </div>
                  <div className={styles.syncLabel}>
                    SYNCING INSTITUTIONAL DATA...{" "}
                    <CountUpNumber target={100} suffix="%" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </section> */}

        {/* ============ FINAL CTA ============ */}
        <section className={`${styles.ctaWrap} page-container`}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <CtaBanner
              title="Unlock Your School's Full Potential "
              // subtitle="Join the growing network of schools using iFillip's school management platform to simplify operations, strengthen academics, and give educators their time back. Book a free 30-minute demo and see how quickly iFillip can fit around the way your campus already works — no disruption, no long implementation, and no forcing your team to change how they teach."
              primaryLabel="Request a Platform Demo"
              primaryHref="/book-demo"
            />
          </motion.div>
        </section>
      </div>
    </>
  );
};

export default WhyIfillip;
